<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-img
          :src="require('@/assets/banner-finantare_alt.png')"
          class="mx-auto"
          contain
          max-height="150px">
        </v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="text-justify">
          Proiectul „S.E.S –Solidaritate, Egalitate, Sustenabilitate”, cod MySMIS 128078 – este cofinantat din Fondul Social European prin Programul Operational Capital Uman, Axa prioritara 4: Incluziunea sociala si combaterea saraciei, Obiectivul tematic 9: Promovarea incluziunii sociale, combaterea saraciei si a oricarei forme de discriminare, Prioritatea de investitii 9.v: Promovarea antreprenoriatului social si a integrarii vocationale in intreprinderile sociale si economia sociala si solidara pentru a facilita accesul la ocuparea fortei de munca, Obiectivul specific 4.16: Consolidarea capacitatii intreprinderilor de economie sociala de a functiona intr-o maniera auto-sustenabila.
        </p>

        <p class="text-h6">
          Obiectivele proiectului
        </p>

        <p class="text-justify">
          Obiectivul general al proiectului consta in consolidarea capacitatii intreprinderilor de economie sociala de a functiona intr-o maniera autosustenabila prin cresterea numarului de entitati de economie sociala in regiunile Nord-Est, Sud-Vest Oltenia, Sud-Muntenia si Sud-Est, in vederea stimularii integrarii pe piata fortei de munca a persoanelor din grupurile vulnerabile si a combaterii saraciei, prin infiintarea de intreprinderi sociale si crearea de noi locuri de munca.
        </p>

        <p class="text-justify">
          Proiectul va contribui la realizarea obiectivului specific al programului si apelului prin furnizarea unui program de formare antreprenorioala specifica si dezvoltarea cunostintelor si competentelor relevante pentru un numar de 105 persoane, in scopul infiintarii si functionarii a 21 de intreprinderi sociale si a crearii de minim 84 de noi locuri de munca durabile si de calitate in regiunile Nord-Est, Sud-Vest Oltenia, Sud-Muntenia si Sud-Est.
        </p>

        <p class="text-justify">
          Prin toate aceste masuri, proiectul va produce un efect pozitiv pe termen lung si anume acela de a contribui la dezvoltarea durabila a regiunilor Nord-Est, Sud-Vest Oltenia, Sud-Muntenia si Sud-Est prin infiintarea si functionarea a 21 de intreprinderi sociale cu minim 84 de locuri de munca nou create, care vor contribui concret la dezvoltarea comunitatilor locale prin crearea de noi locuri de munca, implicarea persoanelor apartinand grupurilor vulnerabile in activitati cu caracter social si economic, facilitand accesul acestora la resursele si serviciile comunitatii la 6 luni dupa terminarea sprijinului.
        </p>

        <p class="text-h6">
          Activitatile prevazute in cadrul proiectului se vor desfasura in doua etape, dupa cum urmeaza:
        </p>

        <p>
          <ul>
            <li>
              Etapa I – Sprijin pentru infiintarea de intreprinderi sociale
            </li>
            <li>
              Etapa a II-a – Implementarea planurilor de afaceri si monitorizarea functionarii intreprinderilor sociale
            </li>
          </ul>
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h1 class="text-h4 text-center">Resurse utile</h1>
        <v-slide-group
          v-model="resursa"
          class="pa-4"
          show-arrows>
          <v-slide-item v-slot:default="{ active, toggle }" v-for="item in resources" :key="item.id">
            <v-hover v-slot:default="{ hover }">
              <v-card
                :color="active ? 'primary lighten-2' : 'grey lighten-4'"
                class="ma-4"
                :elevation="hover ? 4 : 2"
                height="200"
                width="200"
                @click="toggle">
                <v-img
                  :class="{ 'card-image-hover': hover || active }"
                  class="primary--text align-end card-image"
                  height="200px"
                  :src="item.thumb || require('@/assets/file_cabinet.jpg')">
                  <v-expand-transition>
                    <div
                      v-if="hover"
                      class="d-flex transition-fast-in-fast-out primary v-card--reveal text-h6 text-center white--text"
                      style="height: 100%;">
                      {{ item.title }}
                    </div>
                  </v-expand-transition>
                </v-img>
              </v-card>
            </v-hover>
          </v-slide-item>
        </v-slide-group>

        <v-expand-transition>
          <v-sheet color="grey lighten-4" tile>
            <template v-if="resursa != null">
              <div class="ma-0 pa-2" align="center" justify="center">
                <h3 class="title">
                  {{ resources[resursa].title }}
                </h3>
                <div v-html="resources[resursa].content"></div>
                <a :href="resources[resursa].file" target="_blank" download v-if="resources[resursa].file" style="text-decoration: none">
                  Descarca
                  <v-icon right color="primary">
                    mdi-download
                  </v-icon>
                </a>
              </div>
            </template>
            <template v-else>
              <div class="ma-0 pa-2" align="center" justify="center">
                <h3 class="title">
                  Resurse
                </h3>
                <p>
                  Click pe o resursa pentru a putea vedea informatii despre ea si pentru a o putea descarca.
                </p>
              </div>
            </template>
          </v-sheet>
        </v-expand-transition>
      </v-col>
    </v-row>
    <v-row v-if="faq && faq.length">
      <v-col cols="12">
        <h1 class="text-h4 text-center">Intrebari frecvente</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-expansion-panels>
          <v-expansion-panel v-for="item in faq" :key="item.id">
            <v-expansion-panel-header>
              {{ item.title }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="pa-2">
              <div v-html="item.content"></div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "resources",

  data: () => ({
    resursa: null
  }),

  computed: {
    resources() {
      return this.$store.getters.resourcesAllItems;
    },
    faq() {
      return this.$store.getters.faqAllItems;
    }
  },

  mounted() {
    this.$store.dispatch("fetchAllFaq");
    this.$store.dispatch("fetchAllResources");
  }
}
</script>
